import { useContext } from 'react';
import './Style.less';
// import ColorTool from '@/components/colortool/ColorTool';
// import CustomRange from '@/components/customrange/CustomRange';
import Icon from '@/components/iconfont/Icon';
import { EditContext } from '@/context/EditContext';
import { projectController } from '@/api/edit';
import { useTranslation } from 'react-i18next';
export default function Style() {
  const { t } = useTranslation();
  return (
    <div className="style_container">
      <div className="title">{t('As_Edit_Editchoice4')}</div>
      <div className="style_container_main">
        <ContentStyle />
      </div>
    </div>
  );
}
function ContentStyle() {
  const { t } = useTranslation();
  const { sessionId, diyContentStyle, setDiyContentStyle } = useContext(EditContext);
  // // contentstyle的border的数据
  // const [contentBorderColorFlag, setContentBorderColorFlag] = useState(false);
  // // contentstyle的border的数据
  // // contentShadow的数据
  // const [contentShadowColorFlag, setContentShadowColorFlag] = useState(false);
  // // contentShadow的数据

  const handleContentStyleFill = (val) => {
    diyContentStyle.fillModeEnum = val;
    ContentStyleSubmit(diyContentStyle);
    setDiyContentStyle((prev) => ({
      ...prev,
      fillModeEnum: val,
    }));
  };

  const ContentStyleSubmit = async (val) => {
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      const res = projectController.style({
        projectId: projectItem.id,
        body: {
          sessionId,
          contentStyle: val,
        },
      });
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };

  // const handleBorderSizeChange = (val) => {
  //   diyContentStyle.frame.border.size = val;
  //   ContentStyleSubmit(diyContentStyle);
  //   setDiyContentStyle((prve) => ({
  //     ...prve,
  //     frame: {
  //       ...prve?.frame,
  //       border: {
  //         ...prve?.frame.border,
  //         size: val,
  //       },
  //     },
  //   }));
  // };

  // const handleRadiusChange = (val) => {
  //   diyContentStyle.frame.radius = val;
  //   ContentStyleSubmit(diyContentStyle);
  //   setDiyContentStyle((prve) => ({
  //     ...prve,
  //     frame: {
  //       ...prve?.frame,
  //       radius: val,
  //     },
  //   }));
  // };
  // const handleShadowBlurChange = (val) => {
  //   diyContentStyle.frame.shadow.blur = val;
  //   ContentStyleSubmit(diyContentStyle);
  //   setDiyContentStyle((prve) => ({
  //     ...prve,
  //     frame: {
  //       ...prve?.frame,
  //       shadow: {
  //         ...prve?.frame.shadow,
  //         blur: val,
  //       },
  //     },
  //   }));
  // };

  // const handleShadowXOffsetChange = (val) => {
  //   diyContentStyle.frame.shadow.xOffset = val;
  //   ContentStyleSubmit(diyContentStyle);
  //   setDiyContentStyle((prve) => ({
  //     ...prve,
  //     frame: {
  //       ...prve?.frame,
  //       shadow: {
  //         ...prve?.frame.shadow,
  //         xOffset: val,
  //       },
  //     },
  //   }));
  // };

  // const handleShadowYOffsetChange = (val) => {
  //   diyContentStyle.frame.shadow.yOffset = val;
  //   ContentStyleSubmit(diyContentStyle);
  //   setDiyContentStyle((prve) => ({
  //     ...prve,
  //     frame: {
  //       ...prve?.frame,
  //       shadow: {
  //         ...prve?.frame.shadow,
  //         yOffset: val,
  //       },
  //     },
  //   }));
  // };

  // // 修改border颜色
  // const handleBorderColorChange = (val, type) => {
  //   diyContentStyle.frame.border[type] = val;
  //   ContentStyleSubmit(diyContentStyle);
  //   setDiyContentStyle(diyContentStyle);
  // };

  // // 修改shadow颜色
  // const handleShadowColorChange = (val) => {
  //   diyContentStyle.frame.shadow.color = val;
  //   ContentStyleSubmit(diyContentStyle);
  //   setDiyContentStyle((prve) => ({
  //     ...prve,
  //     frame: {
  //       ...prve?.frame,
  //       shadow: {
  //         ...prve?.frame.shadow,
  //         color: val,
  //       },
  //     },
  //   }));
  // };

  // // 修改shadow透明度
  // const handleShadowOpacityChange = (val) => {
  //   diyContentStyle.frame.shadow.opacity = val;
  //   ContentStyleSubmit(diyContentStyle);
  //   setDiyContentStyle((prve) => ({
  //     ...prve,
  //     frame: {
  //       ...prve?.frame,
  //       shadow: {
  //         ...prve?.frame.shadow,
  //         opacity: val,
  //       },
  //     },
  //   }));
  // };

  return (
    <div className="style_common">
      <div className="fill_mode">
        <div>
          <Icon name="icon-fill-mode" className="icon" />
          <span className="text">{t('As_Edit_Fill&FitMode')}</span>
        </div>
        <div className="fill_btn_box">
          <div
            className={`fill_btn ${diyContentStyle?.fillModeEnum === 0 && 'active'}`}
            onClick={() => {
              handleContentStyleFill(0);
            }}>
            {t('As_Edit_ModeOp1')}
          </div>
          <div
            className={`fill_btn ${diyContentStyle?.fillModeEnum === 1 && 'active'}`}
            onClick={() => {
              handleContentStyleFill(1);
            }}>
            {t('As_Edit_ModeOp2')}
          </div>
        </div>
      </div>
      {/* <div className="border_box">
        <div className="border_option">
          <div className="icon_box">
            <Icon name="icon-border" className="icon" />
            {t('As_Edit_BorderAdjust')}
          </div>

          <div className="range_box">
            <CustomRange
              value={diyContentStyle?.frame?.border?.size}
              min={0}
              max={10}
              onChange={(val) => {
                handleBorderSizeChange(val);
              }}
            />
          </div>
        </div>
        <ColorItem
          subtitleColorFlag={contentBorderColorFlag}
          setSubtitleColorFlag={setContentBorderColorFlag}
          color={diyContentStyle?.frame?.border?.color}
          setColor={(val) => {
            handleBorderColorChange(val, 'color');
          }}
          opacity={diyContentStyle?.frame?.border?.opacity}
          setOpacity={(val) => {
            handleBorderColorChange(val, 'opacity');
          }}
        />
      </div>
      <div className="radius_option">
        <div className="icon_box">
          <Icon name="icon-radius" className="icon" />
          {t('As_Edit_RadiusAdjust')}
        </div>
        <div className="range_box">
          <CustomRange
            value={diyContentStyle?.frame?.radius}
            min={0}
            max={200}
            onChange={(val) => {
              handleRadiusChange(val);
            }}
          />
        </div>
      </div>
      <div className="change_shadow_box">
        <div className="text_outline_box">
          <div className="text_outline_main">
            <div className="text_outline_range">
              <div className="icon_text_box">
                <Icon name="icon-blur" className="icon" />
                <span className="text">{t('As_Edit_BlurAdjust')}</span>
              </div>
              <div className="range_box">
                <CustomRange
                  value={diyContentStyle?.frame?.shadow?.blur}
                  min={0}
                  max={50}
                  onChange={(val) => {
                    handleShadowBlurChange(val);
                  }}
                />
              </div>
            </div>
            <div>
              <ColorItem
                subtitleColorFlag={contentShadowColorFlag}
                setSubtitleColorFlag={setContentShadowColorFlag}
                color={diyContentStyle?.frame?.shadow?.color}
                setColor={(val) => {
                  handleShadowColorChange(val);
                }}
                opacity={diyContentStyle?.frame?.shadow?.opacity}
                setOpacity={(val) => {
                  handleShadowOpacityChange(val);
                }}
              />
            </div>
          </div>
          <div className="range_btm_box">
            <div className="range_item">
              <span>X</span>
              <div className="range_box">
                <CustomRange
                  value={diyContentStyle?.frame?.shadow?.xOffset}
                  min={-100}
                  max={100}
                  canNegative={true}
                  iptw={40}
                  onChange={(val) => {
                    handleShadowXOffsetChange(val);
                  }}
                />
              </div>
            </div>
            <div className="range_item">
              <span>Y</span>
              <div className="range_box">
                <CustomRange
                  value={diyContentStyle?.frame?.shadow?.yOffset}
                  min={-100}
                  max={100}
                  canNegative={true}
                  iptw={40}
                  onChange={(val) => {
                    handleShadowYOffsetChange(val);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

// // 颜色选择器组件
// function ColorItem({
//   color,
//   setColor,
//   opacity,
//   setOpacity,
//   subtitleColorFlag,
//   setSubtitleColorFlag,
//   className,
// }) {
//   const [inputColorValue, setInputColorValue] = useState('');
//   useEffect(() => {
//     if (color) {
//       setInputColorValue(color);
//     }
//   }, [color]);
//   const isValidHexColor = (color) => {
//     const hexColorPattern = /^#[0-9A-Fa-f]{6}$/; // 只判断六位的颜色
//     return hexColorPattern.test(color);
//   };
//   const handleChangeColor = (e) => {
//     setInputColorValue(e.target.value);
//   };
//   const handleBlurColor = () => {
//     if (isValidHexColor(inputColorValue)) {
//       setColor(inputColorValue);
//     } else {
//       setInputColorValue(color);
//     }
//   };
//   return (
//     <div className={`color_select_box ${className}`}>
//       <div className={`color_select select_color_btn`}>
//         <div
//           className="color_picker"
//           onClick={() => {
//             setSubtitleColorFlag(!subtitleColorFlag);
//           }}>
//           <div className="color_preview_left" style={{ background: color }}></div>
//           <div
//             className="color_preview_right"
//             style={{ background: color, opacity: opacity + '%' }}></div>
//           <Icon name="icon-colour" className="icon_colour" />
//         </div>
//         <input
//           className="input_color"
//           type="text"
//           value={inputColorValue}
//           onBlur={handleBlurColor}
//           onChange={handleChangeColor}
//         />
//       </div>
//       {subtitleColorFlag && (
//         <div className="color_select_tool">
//           <ColorTool
//             colorValue={color}
//             opacityValue={opacity}
//             setOpacity={setOpacity}
//             onColorChange={setColor}
//             onShow={setSubtitleColorFlag}
//           />
//         </div>
//       )}
//     </div>
//   );
// }
